<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import GemstoneBlock from '../GemstoneBlock.vue'
import MaterialBlock from '../MaterialBlock.vue'
import { ArrowRightIcon } from '@heroicons/vue/20/solid'
import GenderBlock from '../GenderBlock.vue'
import Button from '@/Components/Button.vue'
import { AttributeMenuBlock, GemstoneMenuBlock, GenderMenuBlock, MaterialMenuBlock, NavbarMenu } from '@interfaces/menu.interface'
import AttributeBlock from '../AttributeBlock.vue'

const props = defineProps<{
    menu: NavbarMenu,
}>()

const attributeBlocks = props.menu.blocks.filter((block) => block.type === 'attribute') as AttributeMenuBlock[]
const gemstoneBlock = props.menu.blocks.find((block) => block.type === 'gemstone') as GemstoneMenuBlock
const materialBlock = props.menu.blocks.find((block) => block.type === 'material') as MaterialMenuBlock
const genderBlock = props.menu.blocks.find((block) => block.type === 'gender') as GenderMenuBlock
</script>

<template>
    <div>
        <Button
            :as="Link"
            :href="menu.url"
            color="primary"
            color-variant="plain"
            size="sm"
            class="mb-6 group"
        >
            {{ $t('components.menu.catalog.sections.earrings.link') }}
            <ArrowRightIcon class="w-4 h-4 ml-1 transition-transform duration-300 transform group-hover:translate-x-0.5" />
        </Button>

        <div class="grid grid-cols-3 gap-8">
            <div class="space-y-8">
                <AttributeBlock
                    v-for="block in attributeBlocks"
                    :key="block.code"
                    :block="block"
                />
            </div>

            <GemstoneBlock
                v-if="gemstoneBlock"
                :block="gemstoneBlock"
            />

            <div class="space-y-8">
                <GenderBlock
                    v-if="genderBlock"
                    :block="genderBlock"
                />

                <MaterialBlock
                    v-if="materialBlock"
                    :block="materialBlock"
                />
            </div>
        </div>
    </div>
</template>
